import { Stack, Typography } from '@mui/material';
import { Chip } from 'components/chip';
import { CircleCheck } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useRisks } from 'queries/risks';
import type { CreateSuitabilityTestResponse } from 'queries/suitability';

interface ResultStepProps {
  result: CreateSuitabilityTestResponse;
}

export const ResultStep = ({ result }: ResultStepProps) => {
  const { t } = useTranslation();
  const { data: risks } = useRisks();
  // Etiqueta del perfil desde /risks, casado por order; `risk.key` es la clave i18n.
  const risk = risks?.find((r) => r.order === result.profileOrder);
  const label = risk ? t(risk.key) : '';
  const validUntil = format(parseISO(result.validUntil), 'dd/MM/yyyy');

  return (
    <Stack gap={3} alignItems="center" textAlign="center">
      <CircleCheck size={48} color="#7EBC25" />
      <Typography variant="displayXs">{t('result.title')}</Typography>
      <Typography variant="textMd" sx={{ color: 'text.secondary' }}>
        {t('result.done')}
      </Typography>
      <Stack gap={1} alignItems="center">
        <Typography variant="textSm" sx={{ color: 'text.secondary' }}>
          {t('result.riskProfile')}
        </Typography>
        <Chip color="primary" label={label} />
      </Stack>
      <Typography variant="textXs" sx={{ color: 'text.secondary' }}>
        {t('result.validUntil', { date: validUntil })}
      </Typography>
    </Stack>
  );
};
